import api, { unwrap } from './client';

export async function createPayment(orderId, customerEmail) {
  const body = { orderId };
  if (customerEmail) body.customerEmail = customerEmail;
  return unwrap(await api.post('/payments/create', body));
}

export async function myPayments() {
  return unwrap(await api.get('/payments/my'));
}

export async function listAdminPayments(params = {}) {
  return unwrap(await api.get('/admin/payments', { params }));
}

export async function getAdminPayment(id) {
  return unwrap(await api.get(`/admin/payments/${id}`));
}
